/**
 * テーブルスクロールインジケーターの制御とドラッグ&ドロップスクロール
 */

document.addEventListener('DOMContentLoaded', function() {
    // すべてのテーブルラッパーを取得（複数のクラスに対応）
    const tableWrappers = document.querySelectorAll(
        '.table-wrapper, ' +
        '.scrollable-table, ' +
        '.data-table-wrapper, ' +
        '.condition-table-wrapper, ' +
        '.normal-table-wrapper, ' +
        '.table-fixed-column'
    );
    
    tableWrappers.forEach(function(wrapper) {
        const indicator = wrapper.querySelector('.scroll-indicator');
        
        // ドラッグ&ドロップスクロール機能
        let isDragging = false;
        let startX = 0;
        let scrollLeft = 0;
        
        // マウスイベント
        wrapper.addEventListener('mousedown', function(e) {
            isDragging = true;
            wrapper.style.cursor = 'grabbing';
            wrapper.style.userSelect = 'none';
            startX = e.pageX - wrapper.offsetLeft;
            scrollLeft = wrapper.scrollLeft;
        });
        
        wrapper.addEventListener('mouseleave', function() {
            isDragging = false;
            wrapper.style.cursor = 'grab';
            wrapper.style.userSelect = '';
        });
        
        wrapper.addEventListener('mouseup', function() {
            isDragging = false;
            wrapper.style.cursor = 'grab';
            wrapper.style.userSelect = '';
        });
        
        wrapper.addEventListener('mousemove', function(e) {
            if (!isDragging) return;
            e.preventDefault();
            const x = e.pageX - wrapper.offsetLeft;
            const walk = (x - startX) * 2; // スクロール速度を調整
            wrapper.scrollLeft = scrollLeft - walk;
        });
        
        // タッチイベント
        let touchStartX = 0;
        let touchEndX = 0;
        let isTouchDragging = false;
        
        wrapper.addEventListener('touchstart', function(e) {
            touchStartX = e.changedTouches[0].screenX;
            isTouchDragging = true;
        });
        
        wrapper.addEventListener('touchmove', function(e) {
            if (!isTouchDragging) return;
            e.preventDefault();
            const touchX = e.changedTouches[0].screenX;
            const diff = touchStartX - touchX;
            wrapper.scrollLeft += diff * 0.5; // タッチスクロール速度を調整
            touchStartX = touchX;
        });
        
        wrapper.addEventListener('touchend', function(e) {
            touchEndX = e.changedTouches[0].screenX;
            isTouchDragging = false;
            handleSwipe();
        });
        
        function handleSwipe() {
            const swipeThreshold = 50;
            const diff = touchStartX - touchEndX;
            
            if (Math.abs(diff) > swipeThreshold) {
                // スワイプが検出されたらインジケーターを非表示
                if (indicator) {
                    indicator.classList.add('hidden');
                }
            }
        }
        
        if (indicator) {
            // スクロールイベントを監視
            wrapper.addEventListener('scroll', function() {
                // スクロールが開始されたらインジケーターを非表示
                if (wrapper.scrollLeft > 0) {
                    indicator.classList.add('hidden');
                } else {
                    // スクロール位置が最初に戻ったら再表示
                    indicator.classList.remove('hidden');
                }
            });
            
            // マウスホバーでインジケーターを一時的に非表示
            wrapper.addEventListener('mouseenter', function() {
                if (wrapper.scrollLeft === 0) {
                    indicator.classList.add('hidden');
                }
            });
            
            wrapper.addEventListener('mouseleave', function() {
                if (wrapper.scrollLeft === 0) {
                    indicator.classList.remove('hidden');
                }
            });
        }
        
        // 初期カーソル設定
        wrapper.style.cursor = 'grab';
    });
}); 